// Who runs the tournament and how to reach them, from the organization's
// public profile. On screen long contacts start collapsed; print shows them
// whole

import { useState } from 'react';
import { useOrgProfile } from '../utils/hooks';
import './OrganizerContacts.scss';

// Past this the contacts start collapsed to three lines
const collapseAt = 160;

export default function OrganizerContacts({ org, print = false }) {
  const { profile } = useOrgProfile(org);
  const [open, setOpen] = useState(false);

  if (!profile?.name && !profile?.contacts) return null;

  const { name, contacts } = profile;
  const isLong =
    contacts.length > collapseAt || contacts.split('\n').length > 3;
  const isCollapsed = !print && isLong && !open;

  return (
    <div className={'organizer-contacts' + (print ? ' print' : '')}>
      <p className='label font-14'>Organizer</p>
      <p className='font-medium'>{name}</p>
      {contacts && (
        <p className={'contacts' + (isCollapsed ? ' collapsed' : '')}>
          {contacts}
        </p>
      )}
      {!print && isLong && (
        <button
          className='transparent small'
          onClick={() => setOpen((prev) => !prev)}
        >
          {open ? 'Show less' : 'Show more'}
        </button>
      )}
    </div>
  );
}
